import React from 'react';
import { Link } from 'react-router-dom';
import Clients from '../components/Clients';
import Contact from '../components/Contact';
import Notification from '../components/Notification';

const Footer = () => (
  <div>
    {window.location.href.indexOf('/contact') > 0 ? '' : <Notification />}
    <Contact />
    <Clients />
    <footer id="footer" className="pt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <p className="display-2 mb-2">BusinessDNA</p>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-3">
            <h6 className="text-uppercase">Information</h6>
            <ul className="list-unstyled">
              <li>
                <Link to="/products">Products</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/features">Features</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-3 column">
            <h6 className="text-uppercase">About</h6>
            <ul className="list-unstyled">
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <li>
                <Link to="/">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/">Terms &amp; Conditions</Link>
              </li>
              <li>
                <Link to="/login-register">User Login / Register</Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-3 column">
            <h6 className="text-uppercase">Stay Posted</h6>
            <form>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  title="Enter your email. No spam, we promise!"
                  placeholder="Enter your email..."
                />
              </div>
              <div className="form-group">
                <button
                  className="btn btn-primary text-uppercase small"
                  data-toggle="modal"
                  data-target="#alertModal"
                  type="button"
                >
                  Subscribe!
                </button>
              </div>
            </form>
          </div>
          <div className="col-12 col-lg-2 ml-lg-auto col-md-3 ml-md-0 text-right">
            <h6 className="">DNA Task Manager</h6>
            <ul className="list-unstyled">
              <li>
                <a href="https://tasks.businessdna.net" target="_blank" rel="noopener noreferrer">
                  Account Login
                </a>
              </li>
            </ul>
            <br />
            {/* <h6 className="text-uppercase">Social</h6>
            <br />
            <ul className="list-inline">
              <li className="list-inline-item">
                <a rel="nofollow" href="http://twitter.com/" title="Twitter">
                  <i className="ion-social-twitter-outline" />
                </a>&#xA0;{' '}
              </li>
              <li className="list-inline-item">
                <a rel="nofollow" href="" title="">
                  <i className="ion-social-instagram-outline" />
                </a>&#xA0;{' '}
              </li>
              <li className="list-inline-item">
                <a rel="nofollow" href="" title="Facebook">
                  <i className="ion-social-facebook-outline" />
                </a>&#xA0;{' '}
              </li>
              <li className="list-inline-item">
                <a rel="nofollow" href="" title="Dribbble">
                  <i className="ion-social-dribbble-outline" />
                </a>
              </li>
            </ul> */}
          </div>
          <br />
          <br />
          <hr className="light" />
        </div>
      </div>
    </footer>
  </div>
);
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js